<template>
  <div class="like-content">
    <button
      type="button"
      class="btn btn-transparent"
      :class="{ toggled: toggled, liked: liked }"
      @click="toggleLike"
    >
      <template v-if="!liked">
        <thumb-up-outline-icon />
        <span class="small">Like</span>
      </template>
      <template v-else>
        <thumb-up-icon />
        <span class="small">Liked</span>
      </template>

      <spinner
        v-if="toggling"
        color="var(--blue)"
        :size="23"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    listing: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    looking: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    post: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    comment: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    postId: {
      type: Number,
      required: false,
      default() {
        return null;
      },
    },
    parentCommentId: {
      type: Number,
      required: false,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      type: '',
      liked: false,
      toggled: false,
      toggling: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    current_object() {
      let curObj = {};
      if (this.type === 'listing') {
        curObj = this.listing;
      } else if (this.type === 'looking') {
        curObj = this.looking;
      } else if (this.type === 'post') {
        curObj = this.post;
      } else {
        curObj = this.comment;
      }
      return curObj;
    },
    liked_by_user() {
      let liked = false;
      this.current_object.likes.forEach((like) => {
        if (like.user.id === this.userData.id) {
          liked = true;
        }
      });
      return liked;
    },
  },
  created() {
    if (this.listing.id !== undefined) {
      this.type = 'listing';
      this.liked = this.liked_by_user;
    } else if (this.looking.id !== undefined) {
      this.type = 'looking';
      this.liked = this.liked_by_user;
    } else if (this.post.id !== undefined) {
      this.type = 'post';
      this.liked = this.liked_by_user;
    } else {
      this.type = 'comment';
      this.liked = this.liked_by_user;
    }
  },
  methods: {
    async toggleLike() {
      if (!this.toggling) {
        this.toggling = true;

        let method = 'POST';
        if (this.liked) {
          method = 'DELETE';
        }

        let url = `posts/${this.current_object.id}/toggleLike/`;
        if (this.type === 'comment') {
          url = `comments/${this.current_object.id}/toggleLike/`;
        }

        const responseData = await this.api({
          url,
          method,
          json: { like: !this.liked },
        });

        this.toggling = false;

        if (responseData.status === 200) {
          this.liked = !this.liked;

          this.toggled = false;

          setTimeout(() => {
            this.toggled = true;
          }, 50);

          if (this.type === 'comment') {
            this.$store.dispatch('update_post', { id: this.postId });
          } else {
            this.$store.dispatch('update_post', { id: this.current_object.id });
          }
        } else {
          setTimeout(() => {
            const likeOrUnlike = this.liked ? 'unlike' : 'like';

            alert(
              `Unable to ${likeOrUnlike} ${this.type}. Please check your `
              + 'connection and try again.',
            );
          }, 50);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .like-content {
    width: 52px;
  }

  .btn {
    position: relative;
    text-align: left;

    .small {
      margin-left: 0.25rem;
    }

    .spinner {
      position: absolute;
      left: -4px;
    }
  }

  .liked {
    color: var(--blue);
  }

  .toggled {
    animation-name: scale;
    animation-duration: 0.2s;
    animation-iteration-count: 1;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
  }

  @keyframes scale {
    0%,
    100% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2);
    }
  }
</style>
